import { render, staticRenderFns } from "./partnerOrderStatementsTable.vue?vue&type=template&id=644c0890&"
import script from "./partnerOrderStatementsTable.vue?vue&type=script&lang=ts&"
export * from "./partnerOrderStatementsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports